module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-100.c8fb2f714bbc7bc3e8dfffa916b286dc.woff";